import React from "react";
import { useState } from 'react';
import { toast } from '@/components/ui/sonner';
import { cn } from '@/lib/utils';
import { authService } from '@/services/authService';

export default function ForgetPassword(props) {

    const [email, setEmail] = useState('');
    const [sent, setSent] = useState(false);
    const [emailValid, setEmailValid] = useState(true);

    const handleSubmit = (e) => {
        if (!email) {
            toast.error('\nאנא הכנס כתובת אימייל\n', { duration: 4000, position: 'top-center', style: { direction: 'rtl', fontSize: '24px' } });
            setEmailValid(false);
            e.preventDefault();
            return;
        }
        e.preventDefault();
        setSent(true);
        authService.forgetPassword(email).then(res => {
            if (res.success) {
                toast.success('\nקישור לאיפוס סיסמה נשלח בהצלחה\n', { duration: 4000, position: 'top-center', style: { direction: 'rtl', fontSize: '24px' } });
                setSent(true);
            } else {
                toast.error('\nאירעה שגיאה בשליחת הקישור\n', { duration: 4000, position: 'top-center', style: { direction: 'rtl', fontSize: '24px' } });
            }
        }).catch(() => {
            toast.error('\nאירעה שגיאה בשליחת הקישור\n', { duration: 4000, position: 'top-center', style: { direction: 'rtl', fontSize: '24px' } });
        });
    }

    const backToLogin = (e) => {
        e.preventDefault();
        props.onBackToLogin();
    }

    if (!sent) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-md">
                    <h2 className="text-2xl font-bold mb-6 text-center">איפוס סיסמה</h2>
                    <form className="space-y-4">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700">אימייל</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => { setEmail(e.target.value); setEmailValid(!!e.target.value.length) }}
                                className={cn(
                                    "mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary", !emailValid && 'border-red-500')}
                                placeholder="הכנס אימייל לאיפוס סיסמה"
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-primary text-primary-foreground py-2 px-4 rounded-md hover:bg-primary/90 transition-colors"
                            onClick={handleSubmit}
                        >
                            שלח קישור לאיפוס סיסמה
                        </button>
                        <div className="text-sm text-center text-gray-600 mt-4">
                            חזרת למסך ההתחברות? <a className="text-primary hover:underline" onClick={backToLogin}>התחבר</a>
                        </div>
                    </form>
                </div>
            </div>
        );
    } else {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-md text-center">
                    <h2 className="text-2xl font-bold mb-4">קישור נשלח!</h2>
                    <p className="text-gray-700">קישור לאיפוס הסיסמה נשלח לכתובת האימייל שסיפקת. אנא בדוק את תיבת הדואר הנכנס שלך.</p>
                    <button
                        className="mt-6 bg-primary text-primary-foreground py-2 px-4 rounded-md hover:bg-primary/90 transition-colors"
                        onClick={backToLogin}
                    >
                        חזור להתחברות
                    </button>
                </div>
            </div>
        )
    }
}